import { Carousel, TextLink, TextLinkUnderlineStyle, Theme } from '@nextgen-web-framework/all';
import { Fragment } from 'react';
import { CMSDataType } from '../types/common';

import { ComponentType } from '../../cms/registries/types/propTypes';
import { transformArticleCard, transformPromotionCard, transformResourceCard } from '../../cms/component-transformers';
import ArticleCard from '../ArticleCard/ArticleCard';
import PromotionCard from '../PromotionCard/PromotionCard';
import ResourceCard from '../ResourceCard/ResourceCard';
import styles from './ContentCardCarousel.module.scss';
import { ContentCardCarouselProps } from './types/propsTypes';

const ContentCardCarousel = (props: ContentCardCarouselProps) => {
  const renderContentCard = (item: CMSDataType) => {
    const card: JSX.Element = <></>;
    switch (item?._content_type_uid) {
      case ComponentType.article_card: {
        const articleProps = transformArticleCard(item);
        return <ArticleCard {...articleProps} />;
      }
      case ComponentType.promotion_card: {
        const promotionProps = transformPromotionCard(item);
        return <PromotionCard {...promotionProps} />;
      }
      case ComponentType.resource_card: {
        const resourceProps = transformResourceCard(item);
        return <ResourceCard {...resourceProps} />;
      }
      default: {
        return card;
      }
    }
  };
  return (
    <div className={`${styles['content-card-carousal-container']}`}>
      <div className={`${styles['content-card-carousal-header']}`}>
        <div className={`${styles['content-card-carousal-title']}`}>{props.title}</div>
        <div className={styles['content-carousel-link']}>
          <TextLink
            text={props.link.text ?? ''}
            href={props.link.url}
            target={props.link.target}
            theme={Theme.BLACK}
            underline={TextLinkUnderlineStyle.FIXED}
          />
        </div>
      </div>
      <Carousel id={styles[`content-card-carousel`]} isTileCarousel={true} data-testid="content-card-carousel">
        {props.contentCardCarouselData?.map((item: CMSDataType) => (
          <Fragment key={item?.uid}>{renderContentCard(item)}</Fragment>
        ))}
      </Carousel>
    </div>
  );
};
export default ContentCardCarousel;
